export const UPDATE_GROUP_DRAWER_TEST_ID = "update-group-drawer";
